import {useMachine} from '@xstate/vue'
import {createMachine, assign} from 'xstate'
import {shallowRef} from '@vue/reactivity'

const meetingMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QFsxgC4EsB2UB0ADgIYBOWAxpsdurHgBaYQRjYDEAygBIDyA6gH0ACgEEASgBUAkgGEpogHISOAbQAMAXUSgCAe1iYsu7NpAAPRAFoAjLYCceAKwA2AMzXnax64BMAFkcADkCAGhAAT0RrH2c8VzU1AHZHRL94nx9A50SAXxyw1AwcfGIyTEpqWjwAN0wDACMAGzA2LikAEQBRYXFpOUVldS0kED0DIxMRiwQbW1cnfzU7Zz9na2TnRzDIhH9rPE3ExLWs1z9EwLtAvIK0LFw8El1mzrNyeiJcMDwmZrYeABiAM6YgEYh4ABlOkNTGNDJhjKZppZvIknI4fMlXIFfHZHHZXNtEM4fI48IkrpkvGpNoEgjcQIV7vgni83h8vj8IH8xJ0ZJ0pAA1TrtMGQ7qA4FiGEjOETJFWIJkrw+OwJayuNa+QkRRB2Ox+clBbEUxx+UmZBlM4qPZ5gV7vT4wLk8vkC4Wi8FQgQyLgiBQAcWhmlh+nhiKmVlsgR8eDSmUcSVVriVRIQ0QuB2cBviKWcdL8fitdxtrPt7Kd3wA7kR4bgAboSDJdABXGhgEildDhMRwPTYWAtSUggQiGT8oQSEUynRh+WRhB+QJx1x2RJqfxXROOWxp87LmLLXxrc3BVzFooPMsOjnOmt1qANput9ud0jd3uwfuD-5AkddBQpGnENZTnBFJlAaY1jjLIzWORJrFWYI-DTRxEwOFM-GsJZbDQy18kZEsrztG9Kzwe9mSfZs23QDsux7PtjB-GR-X5CEBGHaUQNncZwIVBAgicJYrjpC53F8UJdQQNxlQJFZLg8FZVQvZlbTZR1OQo4onyEd8GK-JiWjHCcJA4v8uOGHjwwg8w9TUPANWsOlrGNbDfESNM7B8fZ11XNQcQQtYXJU0sSIrTTa0oxtdLIfTvxaACAE0zKlGdRjAiNIL1Bw8X1DYMWsOwnI8qSrjRbNslcFNCqwvw7BC4j1NvatIu06K9M-eLfylH1WM6KF2jSuU+IXS48CK+JAguBC1Xzaw02wlw8B8VwsSXVZNWSBqWTCjTnXokRyHIMACFoiAeAAMwujtWg6bovWDSz0t4zLbIQdcD1SQ4SSCC55qkilYnxVVvC8JyAmsba1PLPbvno9pWEwSBLuukhbq6MUoSGjKbOmD7lq+vNSSmnE00CRC40yQJzjUTUsn8KHr3C51yBfWi31iw7jtO5GrputoMYe7GXtxxB8cxVYid+8myYp09qd8-MSXPAjrUamHmrwVmaLovSEewJHzr5tGBfu8Vhes-jxcJ45ibE2XDXlmm6ZJItVaInamrI3RjZkT5juaCB0bNrHuOey2F2tyXbel-6dnJx2qedpWVsZ3bNfosQ7RkZqg9NzHHtDEX+MsBCyUSUkl2zOZgjsBbogcFVVvcfygjdgjsF0Fh4BGNWoCLiOspmRCaTjRN1jUDwMn8nw00sJcDn1TIsLULCzRBqGu3KKhPloAf5yHmwqsbkfsVXq4aVnqTsTwQIEkSTVnDcWmELpTf323yo6EYZhWH3kbD4N32JPPwtM751TviSBaMYnDmkQqkDcq4irvzKBUXedBagNGaP-V6yIYzLiyHVNU-hJrHGgbGde8DQErX1JDd2l5PYa0rDg0Ww8UzLgCJPdcU8fAzzTH5ckFVow02WNcehqkmawxdGAFhJdHL2U4RPHhfCpIxnsqkZMngzTUzXGnL2EUHxUTZrrWKnVDKyIXJYFueBV4VxJJiGkxC0w-XJJSO+iZaTOD0UwgxUUSAxQ-IxAcMjQLF0saqQ0WQ75VRnqSSenkDRGhxFNPE5oMRiNuAw6GpFOQHSOidM6KMOwWKHimeYXhVpHA1LNE0nlvLklpmqAKHhcLeJyftPWiNeaoxKW9TUsZV74m8KDEmiFPJTUXpVaqBpEL1XEaFfRLNjEc27FzAp3TimhMHn0-w41sTmnvlSHEzg9yZkPG4GIiEk65Hmerdp3xtavnhl0o2PStkHx2YaPE2IqonC8IDVCaEszZELF5IZKtMkSPTt7X2-swCB16dMA0sZ8yX2pthGI3kHaU2QoremELCJZMkRnDq2dc6IqsMEey7hzRLmBkkA0C1MTLifjmf5+Z155DyEAA */
    id: 'meeting',
    predictableActionArguments: true,
    type: 'parallel',
    context: {},
    states: {
      participants: {
        initial: 'hidden',
        states: {
          hidden: {
            on: {
              SHOW_PARTICIPANTS: 'visible',
            },
          },
          visible: {
            on: {
              HIDE_PARTICIPANTS: 'hidden',
            },
          },
        },
      },
      participantsNetwork: {
        initial: 'hidden',
        states: {
          hidden: {
            on: {
              SHOW_PARTICIPANTS_NETWORK: 'visible',
            },
          },
          visible: {
            on: {
              HIDE_PARTICIPANTS_NETWORK: 'hidden',
            },
          },
        },
      },
      notifyDataLimit: {
        initial: 'hidden',
        states: {
          hidden: {
            on: {
              SHOW_MESSAGE_DATA_LIMIT: 'visible',
            },
          },
          visible: {
            on: {
              HIDE_MESSAGE_DATA_LIMIT: 'hidden',
            },
          },
        },
      },
      chat: {
        initial: 'hidden',
        states: {
          hidden: {
            on: {
              SHOW_CHAT: 'visible',
            },
          },
          visible: {
            on: {
              HIDE_CHAT: 'hidden',
            },
          },
        },
      },
      roleExchange: {
        initial: 'idle',
        states: {
          idle: {
            on: {
              OFFER_ROLE: 'waitingForCounterpartyResponse',
              RECEIVED_ROLE_OFFER: 'waitingForPartyResponse',
              RECEIVED_ROLE_CHANGE: 'partyRoleChanged',
            },
          },

          waitingForCounterpartyResponse: {
            on: {
              OFFER_ACCEPTED: 'counterpartyAcceptedOffer',
              OFFER_DENIED: 'counterpartyDeniedOffer',
              CANCEL_OFFER: 'offerCanceled',
            },
          },

          waitingForPartyResponse: {
            on: {
              ACCEPT_OFFER: 'partyAcceptedOffer',
              DENY_OFFER: 'partyDeniedOffer',
              OFFER_CANCELED: 'offerCanceled',
            },
          },

          partyAcceptedOffer: {
            on: {
              HIDE_ROLE: 'idle',
            },
          },

          partyDeniedOffer: {
            on: {
              HIDE_ROLE: 'idle',
            },
          },

          counterpartyAcceptedOffer: {
            on: {
              HIDE_ROLE: 'idle',
            },
          },

          counterpartyDeniedOffer: {
            on: {
              HIDE_ROLE: 'idle',
            },
          },

          offerCanceled: {
            on: {
              HIDE_ROLE: 'idle',
            },
          },

          partyRoleChanged: {
            on: {
              HIDE_ROLE: 'idle',
            },
          },
        },
      },
      mobileUtilityMenu: {
        initial: 'hidden',
        states: {
          hidden: {
            on: {
              SHOW_MEETING_MOBILE_UTILITY_MENU: 'visible',
            },
          },
          visible: {
            on: {
              HIDE_MEETING_MOBILE_UTILITY_MENU: 'hidden',
            },
          },
        },
      },
    },
  },
  {
    actions: {},
  }
)

const {state: machineState, send, service} = useMachine(meetingMachine)
const state = shallowRef(machineState)
service.subscribe(_state => {
  console.info(`MeetingMachine received event ${_state.event.type}`)
  state.value = _state
})

export default function () {
  return {state, send, service}
}
